/**
 * The ARIA label for the months dropdown.
 *
 * @defaultValue `"Choose the Month"`
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */
export function labelMonthDropdown(options) {
    return "Choose the Month";
}
//# sourceMappingURL=labelMonthDropdown.js.map